import { colors } from '@lmc/common/constants'
import { Icon } from '@lmc/ui-kit'
import { find } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import AnimateHeight from 'react-animate-height'
import CarePlanHistoryRevision from './CarePlanHistoryRevision'

export default class CarePlanHistoryItem extends React.Component {
  state = {
    isOpen: false
  }

  toggleOpen = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen
    }))
  }

  render() {
    const { carers, onClickRevision, title, revisions, style } = this.props

    const { isOpen } = this.state
    return (
      <div
        style={{
          ...style,
          ...styles.wrapper
        }}
      >
        <div
          className={'lmc-care-plan-history-expandable'}
          onClick={this.toggleOpen}
          style={styles.titleBar}
        >
          <span style={styles.title}>{title}</span>
          <Icon
            name={isOpen ? 'UpOutlined' : 'DownOutlined'}
            style={styles.glyph}
          />
        </div>
        <AnimateHeight
          animateOpacity={true}
          height={isOpen ? 'auto' : 0}
          duration={300}
        >
          {revisions.map((revision) => {
            const carer = find(carers, { id: revision.editedBy })
            return (
              <CarePlanHistoryRevision
                carePlan={revision}
                carer={carer}
                key={revision.id}
                onClick={onClickRevision}
                style={styles.revision}
              />
            )
          })}
        </AnimateHeight>
      </div>
    )
  }
}

const styles = {
  glyph: {
    alignSelf: 'flex-end',
    fontSize: 24
  },
  revision: {
    marginTop: 5
  },
  title: {
    fontSize: 20
  },
  titleBar: {
    borderBottom: `2px solid ${colors.grey}`,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 15px 3px 2px'
  },
  wrapper: {}
}

CarePlanHistoryItem.propTypes = {
  carers: PropTypes.array.isRequired,
  onClickRevision: PropTypes.func.isRequired,
  revisions: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired
}
